import callApi, { callExternalApi } from './apiCaller';
// import { uploadFile as s3UploadFile, getFile as s3GetFile, streamFile, listFiles, deleteFile as s3DeleteFile } from './aws/s3';


export function getFileUrl(filename, userId = null) {
    return new Promise((resolve, reject) => {
        getFileContent(filename, userId).then(result => {
            let fileUrl = '';
            if(result.content) {
                fileUrl = URL.createObjectURL(new Blob([result.content], { type: result.contentType }));
            } else if(result.url) {
                fileUrl = result.url;
            }
            resolve(fileUrl);
        }).catch(error => {
            console.error('getFileUrl', error);
            reject(error);
        });
    });
}

export function getFileContent(filename, userId = null, forceContent = false) {
    return new Promise((resolve, reject) => {
        callApi('file/geturl', 'post', { filename, userId }).then(result => {
            if(result.url) {
                if(result.encodingKey || forceContent) {
                    callExternalApi(result.url).then(result => {
                        resolve({
                            content: result.Body,
                            contentType: result.ContentType,
                        });
                    }).catch(reject);
                    // s3GetFile(filename, result.encodingKey).then(result => {
                    //     resolve({
                    //         content: result.Body,
                    //         contentType: result.ContentType,
                    //     });
                    // }).catch(error => {
                    //     console.error(error);
                    //     reject(error);
                    // });
                } else {
                    resolve({
                        url: result.url,
                    });
                }
            } else {
                reject(new Error('noFileError'));
            }
        }).catch(error => {
            console.error('getFileContent', error);
            reject(error);
        });
    });
}


export function uploadFile(fileName, data, contentType = '', userId = null, isPublic = false) {
    return new Promise((resolve, reject) => {
        callApi('file/geturl', 'post', { filename: fileName, 'method': 'put', userId, isPublic }).then(result => {
            if(result.url) {
                callExternalApi(result.url, 'put', data, { 'Content-Type': contentType }).then(() => {
                    resolve();
                }).catch(reject);

                // s3UploadFile(fileName, data, isPublic ? '' : result.encodingKey).then(result => {
                //     resolve(result);
                // }).catch(error => {
                //     console.error(error);
                //     reject(error);
                // });
            } else {
                reject(new Error('noUploadUrl'));
            }
        }).catch(error => {
            console.error('uploadFile', error);
            reject(error);
        });
    });
}


// export function getFiles(path) {
//     return new Promise((resolve, reject) => {
//         listFiles(path).then(result => {
//             if(result) {
//                 resolve(result.Contents.map(content => {
//                     console.log(content);
//                     return content.Key;
//                 }));
//             } else {
//                 reject(new Error());
//             }
//         }).catch(error => {
//             console.error(error);
//             reject(error);
//         });
//     });
// }


export function deleteFile(path) {
    return new Promise((resolve, reject) => {
        callApi('/file/delete', 'delete', { filename: path }).then(result => {
            resolve();
        }).catch(error => {
            console.error(error);
            reject(error);
        });
    });
}
